import * as mutationTypes from '../mutation-types'
import * as actionTypes from '../action-types'
import axios from 'axios/index'
import { clearFilters, getAppliedFilters } from '../../HelperMethods'
import store from '../../store'
import moment from 'moment-es6'
import Vue from 'vue'
import { concatCustomFilters, solveCustomFilters } from './students'
import {components, componentTitles} from './rightDrawer'
import { undoTypes } from './undo'
import { informationTexts } from './information'

const state = {
  studentsCount: 0,
  studentRatingCounts: [],
  dashboardAlerts: {
    yesterday: null,
    lastWeek: null,
    lastMonth: null
  },
  interventionCounts: {
    inProgress: 0,
    isNew: 0,
    delayed: 0
  },
  dashboardJobs: [],
  engagementLastSuccess: '',
  loading: false,
  filterFields: {
    myTutees: {
      isNotTutor: true,
      values: {
        MY_TUTEES: {
          value: false,
          text: 'student.filters.values.my_tutees'
        }
      }
    }
  },
  availableCharts: [],
  preRenderGraphs: false,
  dashboardGraphsData: [],
  dashboardGraphs: [],
  errorMessage: '',
  startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
  endDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
  startDateDisabled: false,
  endDateDisabled: false,
  lastWeekNumber: -1,
  hideFilters: false,
  customFilters: {},
  customListSources: {},
  customFilterNames: [],
  reorderDialogVisible: false,
  createChartDialogVisible: false,
  chartFilterFields: {
    myFilterIds: {
      header: 'student.filters.headers.myFilters',
      isList: true,
      listName: 'myFilterIds',
      values: {},
      myFilters: []
    },
    myTutees: {
      header: 'student.filters.headers.tutees',
      isNotTutor: true,
      values: {
        MY_TUTEES: {
          value: false,
          text: 'student.filters.values.my_tutees'
        }
      }
    },
    engagementRatings: {
      header: 'student.filters.headers.engagement',
      values: {
        NONE: {
          value: false,
          text: 'student.filters.values.none',
          index: 0
        },
        VERY_LOW: {
          value: false,
          text: 'student.filters.values.very_low',
          index: 1
        },
        LOW: {
          value: false,
          text: 'student.filters.values.low',
          index: 2
        },
        PARTIAL: {
          value: false,
          text: 'student.filters.values.partial',
          index: 3
        },
        GOOD: {
          value: false,
          text: 'student.filters.values.good',
          index: 4
        },
        HIGH: {
          value: false,
          text: 'student.filters.values.high',
          index: 5
        }
      }
    },
    averageEngagementRatings: {
      header: 'student.filters.headers.average',
      values: {
        NONE: {
          value: false,
          text: 'student.filters.values.none',
          index: 0
        },
        VERY_LOW: {
          value: false,
          text: 'student.filters.values.very_low',
          index: 1
        },
        LOW: {
          value: false,
          text: 'student.filters.values.low',
          index: 2
        },
        PARTIAL: {
          value: false,
          text: 'student.filters.values.partial',
          index: 3
        },
        GOOD: {
          value: false,
          text: 'student.filters.values.good',
          index: 4
        },
        HIGH: {
          value: false,
          text: 'student.filters.values.high',
          index: 5
        }
      }
    },
    courseIds: {
      header: 'student.filters.headers.courses',
      isList: true,
      listName: 'courseIds',
      values: {},
      courses: []
    }
  },
  listSources: {
    courseIds: {
      identifier: 'course',
      title_i18n: 'student.filters.course_selection',
      items: [],
      idValues: {},
      button_i18n: 'student.filters.courses_button',
      button_unselected_i18n: 'student.filters.courses_button_unselected',
      containsText (item, text) {
        return (item.courseDescription.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
          (item.courseIdentifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
      },
      key (item) {
        return item.courseIdentifier
      },
      mapRow (item) {
        return {
          rows: [item.courseDescription, item.courseIdentifier],
          id: item.id
        }
      }
    },
    myFilterIds: {
      identifier: 'myFilter',
      title_i18n: 'student.filters.myfilter_selection',
      items: [],
      idValues: {},
      button_i18n: '{count} myFilter ::: {count} myFilters',
      button_unselected_i18n: 'student.filters.myfilter_button_unselected',
      containsText (item, text) {
        return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
          (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0)
      },
      key (item) {
        return item.description
      },
      mapRow (item) {
        return {
          rows: [item.description],
          id: item.id,
          defaultSearch: item.defaultSearch
        }
      }
    }
  },
  selectedChartId: null,
  showFilterDefaultOption: false,
  showFilterDeleteOption: false,
  chartUpdated: false,
  updatedChartId: -1,
  chartsLoading: false,
  lastDeletedChartId: null,
  chartsCached: false,
  functions: {
    dashboard: 'DASHBOARD',
    chart: 'CHART'
  },
  options: {
    enable: {
      alertsCard: 'ENBALTCARD',
      createChart: 'ENDCREATE',
      interactionsCard: 'ENBINTCARD'
    },
    disable: {
      chartDelete: 'DISDELETE',
      fourWeekRestriction: 'DIS4WKRES'
    }
  }
}

const mutations = {
  [mutationTypes.SET_STUDENTS_COUNT] (state, value) {
    state.studentsCount = value
  },
  [mutationTypes.SET_STUDENTS_RATINGS_COUNT] (state, counts) {
    state.studentRatingCounts = counts
  },
  [mutationTypes.SET_DASHBOARD_ALERTS] (state, alerts) {
    state.dashboardAlerts = alerts
  },
  [mutationTypes.SET_DASHBOARD_LAST_SUCCESSFUL_JOBS] (state, jobs) {
    state.dashboardJobs = jobs
  },
  [mutationTypes.SET_ENGAGEMENT_LAST_SUCCESSFUL] (state, date) {
    state.engagementLastSuccess = date
  },
  [mutationTypes.RESET_DASHBOARD_MODULE] (state) {
    state.studentsCount = 0
    state.studentRatingCounts = []
    state.dashboardAlerts = {}
    state.dashboardJobs = []
    state.dashboardGraphs = []
    state.dashboardGraphsData = []
    state.chartUpdated = false
  },
  [mutationTypes.SET_INTERVENTION_COUNT] (state, counts) {
    state.interventionCounts = counts
  },
  [mutationTypes.SET_IS_TUTOR] (state, isNotTutor) {
    state.filterFields.myTutees.isNotTutor = !isNotTutor
  },
  [mutationTypes.DASHBOARD_LOADING] (state) {
    state.loading = true
  },
  [mutationTypes.DASHBOARD_CHARTS_LOADING] (state) {
    state.chartsLoading = true
  },
  [mutationTypes.DASHBOARD_CHARTS_NOT_LOADING] (state, err) {
    // if received all graph data or if chart has crashed
    // other charts were not activated if one had an error
    if (state.dashboardGraphs.length === state.dashboardGraphsData.length || err) {
      state.chartsLoading = false
    }
  },
  [mutationTypes.SET_REORDER_CHART_DIALOG_VISIBILITY] (state, value) {
    state.reorderDialogVisible = value
  },
  [mutationTypes.SET_CREATE_CHART_DIALOG_VISIBILITY] (state, value) {
    state.createChartDialogVisible = value
  },
  [mutationTypes.HIDE_CHART_FILTERS] (state, hide) {
    state.hideFilters = !hide ? false : hide
  },
  [mutationTypes.DASHBOARD_CHARTS_CACHED] (state) {
    state.chartsCached = true
  },
  [mutationTypes.DASHBOARD_CHARTS_NOT_CACHED] (state) {
    state.chartsCached = false
  },
  [mutationTypes.TOGGLE_DASHBOARD_FILTER] (state, {filterType, filterName, value}) {
    state.filterFields[filterType].values[filterName].value = value !== undefined ? value : !state.filterFields[filterType].values[filterName].value
  },
  [mutationTypes.CLEAR_DASHBOARD_FILTERS] (state) {
    state.filterFields = clearFilters(state.filterFields)
  },
  [mutationTypes.SET_DASHBOARD_AVAILABLE_CHARTS] (state, charts) {
    state.availableCharts = charts
  },
  [mutationTypes.SET_DASHBOARD_PRE_RENDER_GRAPHS] (state, status) {
    state.preRenderGraphs = status
  },
  [mutationTypes.REFRESH_PRIMARY_DASHBOARD_GRAPHS_SEQUENCE] (state, graphs) {
    state.dashboardGraphs = refreshSeq(graphs, 'primarySequence')
  },
  [mutationTypes.REFRESH_SECONDARY_DASHBOARD_GRAPHS_SEQUENCE] (state, graphs) {
    state.dashboardGraphs = refreshSeq(graphs, 'secondarySequence')
  },
  [mutationTypes.RESET_DASHBOARD_GRAPHS_SEQUENCE] (state) {
    state.dashboardGraphs = state.dashboardGraphs.sort((a, b) => a.primarySequence - b.primarySequence)
  },
  [mutationTypes.SET_DASHBOARD_GRAPHS] (state, graphs) {
    graphs.forEach(el => {
      el.isHidden = false
      el.chartTitle = el.search ? el.search.description : el.chartTitle
      el.secondarySequence = el.primarySequence
      el.chartLabels = el.chartType === 'DOUGHNUT' ? store.state.config.ratingLabel : el.chartLabels
    })
    state.dashboardGraphs = graphs
  },
  [mutationTypes.APPEND_DASHBOARD_GRAPH] (state, graph) {
    graph.isHidden = false
    state.dashboardGraphs.unshift(graph)
  },
  [mutationTypes.RESET_DASHBOARD_GRAPHS_DATA] (state) {
    state.dashboardGraphsData = []
  },
  [mutationTypes.SET_DASHBOARD_GRAPHS_DATA] (state, graphData) {
    state.dashboardGraphsData.push(graphData)
  },
  [mutationTypes.APPEND_DASHBOARD_GRAPH_DATA] (state, graphData) {
    state.dashboardGraphsData.unshift(graphData)
  },
  [mutationTypes.UPDATE_DASHBOARD_GRAPH_DATA] (state, graphData) {
    state.dashboardGraphsData.forEach(el => {
      if (el.id === graphData.id) {
        el.chartData = graphData.chartData
      }
    })
  },
  [mutationTypes.HIDE_CHART_BY_ID] (state, id) {
    state.dashboardGraphs.filter(el => el.id === id)[0].isHidden = true
  },
  [mutationTypes.SHOW_CHART_BY_ID] (state, id) {
    state.dashboardGraphs.filter(el => el.id === id)[0].isHidden = false
  },
  [mutationTypes.SAVE_DELETED_CHART_ID] (state, id) {
    state.lastDeletedChartId = id
  },
  [mutationTypes.SET_CHART_UPDATED] (state, value) {
    state.chartUpdated = value
  },
  [mutationTypes.SET_UPDATED_CHART_ID] (state, value) {
    state.updatedChartId = value
  },
  [mutationTypes.SET_CHART_FILTER_START_DATE] (state, value) {
    state.startDate = value
  },
  [mutationTypes.SET_CHART_FILTER_END_DATE] (state, value) {
    state.endDate = value
  },
  [mutationTypes.SET_SELECTED_CHART_ID] (state, id) {
    state.selectedChartId = id
  },
  [mutationTypes.REFRESH_CHART_DATES] (state) {
    state.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
    state.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    state.endDateDisabled = false
    state.startDateDisabled = false
    state.lastWeekNumber = -1
  },
  [mutationTypes.SET_CHART_START_DATE_FILTER] (state, startDate) {
    if (startDate) {
      state.startDate = moment(startDate).format('YYYY-MM-DD')
      state.startDateDisabled = false
    } else {
      state.startDate = null
      state.startDateDisabled = true
    }
  },
  [mutationTypes.SET_CHART_END_DATE_FILTER] (state, endDate) {
    if (endDate) {
      state.endDate = moment(endDate).format('YYYY-MM-DD')
      state.endDateDisabled = false
    } else {
      state.endDate = null
      state.endDateDisabled = true
    }
  },
  [mutationTypes.SET_CHART_LAST_WEEK_NUMBER] (state, lastWeekNumber) {
    state.lastWeekNumber = lastWeekNumber < 1 ? -1 : lastWeekNumber
  },
  [mutationTypes.CLEAR_CHART_FILTERS_LIST] (state) {
    state.chartFilterFields = clearFilters(state.chartFilterFields)
  },
  [mutationTypes.SET_CHART_TITLE] (state, chart) {
    let obj = state.dashboardGraphs.filter(el => el.id === chart.chartId)[0]
    obj.chartTile = chart.title
    state.dashboardGraphs.filter(el => el.id === chart.chartId)[0] = obj
  },
  [mutationTypes.TOGGLE_CHARTS_LIST_FILTER] (state, {filterType, filterName}) {
    // if array has multiple elements
    if (Array.isArray(filterName)) {
      filterName.forEach(item => {
        state.chartFilterFields[filterType].values[item].value = !state.chartFilterFields[filterType].values[item].value
      })
    } else {
      if (filterType !== 'myTutees') {
        state.chartFilterFields[filterType].values[filterName].value = !state.chartFilterFields[filterType].values[filterName].value
      }
    }
  },
  [mutationTypes.SET_CHARTS_LIST_FILTER_ARRAY] (state, {filterType, filterName}) {
    let items = {}
    filterName.forEach(item => {
      items[item] = {value: true}
    })
    state.chartFilterFields[filterType].values = items
    state.listSources[filterType].idValues = items
  },
  [mutationTypes.SET_SAVED_FILTERS_FOR_CHARTS] (state, filters) {
    state.chartFilterFields.myFilterIds.myFilters = filters
    state.listSources.myFilterIds.items = filters
    // set default button description
    Object.keys(filters).forEach(filter => {
      if (filters[filter].defaultSearch) {
        state.listSources.myFilterIds.button_i18n = filters[filter].description
      }
    })
  },
  [mutationTypes.SET_COURSES_FOR_CHARTS] (state, courses) {
    state.chartFilterFields.courseIds.courses = courses
    state.listSources.courseIds.items = courses
  },
  [mutationTypes.SET_CHART_CUSTOM_BUTTON_FILTER_TYPE] (state, {filters, filter, filterIdentifier}) {
    if (!state.customFilterNames[filterIdentifier]) {
      state.customFilterNames.push(filterIdentifier)
      let filterObject = {}
      filterObject.filterName = filterIdentifier
      filterObject[filterIdentifier] = {}
      filterObject[filterIdentifier].header = filters[filter].description
      filterObject[filterIdentifier].values = {}

      Object.keys(filters[filter]['filterTypeCodes']).forEach((filterValue) => {
        let filterTypeCodes = filters[filter]['filterTypeCodes'][filterValue]
        filterObject[filterIdentifier].values[filterTypeCodes.code] = {}
        filterObject[filterIdentifier].values[filterTypeCodes.code].value = false
        filterObject[filterIdentifier].values[filterTypeCodes.code].text = filterTypeCodes.description
      })
      // add to state.filterFields object
      Vue.set(state.chartFilterFields, filterObject.filterName, filterObject[filterObject.filterName])
    }
  },
  [mutationTypes.SET_CHART_CUSTOM_LIST_FILTER_TYPE] (state, {filters, filter, filterIdentifier}) {
    if (!state.customFilterNames.includes(filterIdentifier)) {
      state.customFilterNames.push(filterIdentifier)
      let filterObject = {}
      filterObject.filterName = filterIdentifier
      filterObject[filterIdentifier] = {}
      filterObject[filterIdentifier].header = filters[filter].description
      filterObject[filterIdentifier].isList = true
      filterObject[filterIdentifier].listName = filterIdentifier
      filterObject[filterIdentifier].values = {}

      filterObject[filterIdentifier][filterIdentifier] = []
      let filterListArray = filterObject[filterIdentifier][filterIdentifier]
      Object.keys(filters[filter]['filterTypeCodes']).forEach((filterValue) => {
        let filterTypeCodes = filters[filter]['filterTypeCodes'][filterValue]
        filterObject[filterIdentifier].values[filterTypeCodes.code] = {}
        filterObject[filterIdentifier].values[filterTypeCodes.code].value = false
        filterObject[filterIdentifier].values[filterTypeCodes.code].text = filterTypeCodes.description

        let filterListObject = {}
        filterListObject.id = filterTypeCodes.id
        filterListObject.description = filterTypeCodes.description
        filterListObject.identifier = filterTypeCodes.code
        filterListArray.push(filterListObject)
      })
      // add to state.filterFields object
      Vue.set(state.chartFilterFields, filterObject.filterName, filterObject[filterObject.filterName])

      let source = {}
      source[filterIdentifier] = {}
      source[filterIdentifier].identifier = filterIdentifier
      source[filterIdentifier].title_i18n = filters[filter].description
      source[filterIdentifier].items = filterListArray
      source[filterIdentifier].idValues = {}
      source[filterIdentifier].button_i18n = '{count} ' + filters[filter]['description'] + ' ::: {count} ' + filters[filter]['additionalDescription']
      source[filterIdentifier].button_unselected_i18n = filters[filter]['additionalDescription']
      source[filterIdentifier].containsText = function containsText (item, text) {
        return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
          (item.identifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
      }
      source[filterIdentifier].key = function key (item) {
        return item.identifier
      }
      source[filterIdentifier].mapRow = function mapRow (item) {
        return {
          rows: [item.description, item.identifier],
          id: item.identifier
        }
      }
      // add to state.listSources object
      Vue.set(state.listSources, filterIdentifier, source[filterIdentifier])
    }
  },
  [mutationTypes.SET_CHART_BUTTON_FILTER_TYPE] (state, {filters, chartFilterObject}) {
    let filterObject = {}
    filterObject.filterName = chartFilterObject.filterIdentifier
    filterObject.header = chartFilterObject.filterAdditionalDescription
    filterObject.values = {}
    Object.keys(filters).forEach((filter) => {
      filterObject.values[filters[filter].code] = {}
      filterObject.values[filters[filter].code].value = false
      filterObject.values[filters[filter].code].text = filters[filter].description
    })
    // add to state.filterFields object
    Vue.set(state.chartFilterFields, filterObject.filterName, filterObject)
  },
  [mutationTypes.SET_CHART_LIST_FILTER_TYPE] (state, {filters, chartFilterObject}) {
    let filterObject = {}
    let filterIdentifier = chartFilterObject.filterIdentifier

    filterObject.filterName = chartFilterObject.filterIdentifier
    filterObject[filterIdentifier] = {}
    filterObject[filterIdentifier].header = chartFilterObject.filterAdditionalDescription
    filterObject[filterIdentifier].isList = true
    filterObject[filterIdentifier].listName = chartFilterObject.filterIdentifier
    filterObject[filterIdentifier].values = {}

    filterObject[filterIdentifier][filterIdentifier] = []
    let filterListArray = filterObject[filterIdentifier][filterIdentifier]
    let iterator = filters.keys()
    for (let key of iterator) {
      filterObject[filterIdentifier].values[filters[key].code] = {}
      filterObject[filterIdentifier].values[filters[key].code].value = false
      filterObject[filterIdentifier].values[filters[key].code].text = filters[key].description

      let filterListObject = {}
      filterListObject.id = key
      filterListObject.description = filters[key].description
      filterListObject.identifier = filters[key].code
      filterListArray.push(filterListObject)
    }
    // add to state.filterFields object
    Vue.set(state.chartFilterFields, filterObject.filterName, filterObject[filterObject.filterName])

    let source = {}
    source[filterIdentifier] = {}
    source[filterIdentifier].identifier = filterIdentifier
    source[filterIdentifier].title_i18n = chartFilterObject.filterName
    source[filterIdentifier].items = filterListArray
    source[filterIdentifier].idValues = {}
    source[filterIdentifier].button_i18n = '{count} ' + chartFilterObject.filterName + ' ::: {count} ' + chartFilterObject.filterAdditionalDescription
    source[filterIdentifier].button_unselected_i18n = chartFilterObject.filterAdditionalDescription
    source[filterIdentifier].containsText = function containsText (item, text) {
      if (filterIdentifier === 'courseYears') {
        return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
          ((item.identifier + '').toUpperCase().indexOf(text.toUpperCase()) >= 0)
      } else {
        return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
          (item.identifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
      }
    }
    source[filterIdentifier].key = function key (item) {
      return item.identifier
    }
    source[filterIdentifier].mapRow = function mapRow (item) {
      return {
        rows: [item.description, item.identifier],
        id: item.identifier
      }
    }
    // add to state.listSources object
    Vue.set(state.listSources, filterIdentifier, source[filterIdentifier])
  }
}

const actions = {
  [actionTypes.GET_MYTUTEES_DEFAULT_ENABLED] ({rootState, state, commit}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/search/default/myTutees/enabled`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: actionTypes.GET_MYTUTEES_DEFAULT_ENABLED }
    })
      .then((res) => {
        commit(mutationTypes.TOGGLE_STUDENTS_LIST_FILTER, {filterType: 'myTutees', filterName: 'MY_TUTEES', value: res.data})
        commit(mutationTypes.TOGGLE_DASHBOARD_FILTER, {filterType: 'myTutees', filterName: 'MY_TUTEES', value: res.data})
        commit(mutationTypes.TOGGLE_INTERACTIONS_LIST_FILTER, {filterType: 'myTutees', filterName: 'MY_TUTEES', value: res.data})
        /* store.dispatch(actionTypes.GET_STUDENTS_COUNT)
        store.dispatch(actionTypes.GET_LATEST_ENGAGEMENT_COUNT)
        store.dispatch(actionTypes.GET_DASHBOARD_ALERTS_COUNT)
        store.dispatch(actionTypes.GET_INTERVENTION_COUNT) */
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [actionTypes.GET_STUDENTS_COUNT] ({commit, rootState}) {
    const actionData = { action: actionTypes.GET_STUDENTS_COUNT, data: undefined }
    store.dispatch(actionTypes.GET_TUTOR_BOOLEAN)
    store.dispatch(actionTypes.GET_CHART_LIMIT_BOOLEAN)
    let filters = getAppliedFilters(state.filterFields)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/mytutees/count`,
      method: 'post',
      data: {
        ...filters
      },
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
    .then((res) => {
      commit(mutationTypes.SET_STUDENTS_COUNT, res.data)
    })
    .catch((err) => {
      console.log('Failed to get student count')
      console.error(err)
    })
  },
  [actionTypes.GET_LATEST_ENGAGEMENT_COUNT] ({commit, rootState}) {
    const actionData = { action: actionTypes.GET_LATEST_ENGAGEMENT_COUNT }
    commit(mutationTypes.SET_STUDENTS_RATINGS_COUNT, [])
    let filters = getAppliedFilters(state.filterFields)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/engagement/mytutees/latest/count`,
      method: 'post',
      data: {
        ...filters
      },
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
    .then((res) => {
      let values = {}
      res.data.forEach(row => {
        values[row.object] = row.count
      })
      let counts = [values.NONE, values.VERY_LOW, values.LOW, values.PARTIAL, values.GOOD, values.HIGH]
      commit(mutationTypes.SET_STUDENTS_RATINGS_COUNT, counts)
    })
    .catch((err) => {
      console.log('Failed to get engagement')
      console.error(err)
    })
  },
  [actionTypes.GET_DASHBOARD_ALERTS_COUNT] ({rootState, state, commit, getters}) {
    // flagEnableAlertsCard
    if (getters.HAS_FEATURE_FLAG(rootState.profile.module.alert + '.' + state.functions.dashboard + '.' + state.options.enable.alertsCard)) {
      const actionData = {action: actionTypes.GET_DASHBOARD_ALERTS_COUNT}
      let filters = getAppliedFilters(state.filterFields)
      axios({
        url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/mytutees/count`,
        method: 'post',
        data: {
          ...filters
        },
        headers: {
          'Authorization': rootState.profile.loginToken
        },
        actionData
      })
        .then((res) => {
          commit(mutationTypes.SET_DASHBOARD_ALERTS, res.data)
        })
        .catch((err) => {
          console.log('Failed to get alert count')
          console.error(err)
        })
    }
  },
  [actionTypes.GET_INTERVENTION_COUNT] ({commit, rootState, getters}) {
    // flagEnableInteractionsCard
    if (getters.HAS_FEATURE_FLAG(rootState.profile.module.interexem + '.' + state.functions.dashboard + '.' + state.options.enable.interactionsCard)) {
      const actionData = {action: actionTypes.GET_INTERVENTION_COUNT}
      let filters = getAppliedFilters(state.filterFields)
      axios({
        url: `${rootState.config.baseUrl}:${rootState.config.port}/core/intervention/mytutees/count`,
        method: 'post',
        data: {
          ...filters
        },
        headers: {
          'Authorization': rootState.profile.loginToken
        },
        actionData
      }).then((response) => {
        let values = {}
        response.data.forEach(row => {
          values[row.object] = row.count
        })
        let counts = {
          inProgress: values.IN_PROGRESS,
          isNew: values.NEW,
          delayed: values.DELAYED
        }
        commit(mutationTypes.SET_INTERVENTION_COUNT, counts)
      })
        .catch((err) => {
          console.log('Failed to get intervention count')
          console.error(err)
        })
    }
  },
  [actionTypes.GET_ENGAGEMENT_LAST_SUCCESSFUL] ({rootState, state, commit}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/connect/engagement/lastSuccess`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: actionTypes.GET_ENGAGEMENT_LAST_SUCCESSFUL }
    })
      .then((res) => {
        commit(mutationTypes.SET_ENGAGEMENT_LAST_SUCCESSFUL, res.data.lastSuccessDate)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [actionTypes.GET_DASHBOARD_LAST_SUCCESSFUL_JOBS] ({rootState, state, commit}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/connect/get`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: actionTypes.GET_DASHBOARD_LAST_SUCCESSFUL_JOBS }
    })
      .then((res) => {
        commit(mutationTypes.SET_DASHBOARD_LAST_SUCCESSFUL_JOBS, res.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [actionTypes.LOGOUT] (context) {
    context.commit(mutationTypes.RESET_DASHBOARD_MODULE)
    context.commit(mutationTypes.CLEAR_DASHBOARD_FILTERS)
    context.commit(mutationTypes.DASHBOARD_CHARTS_NOT_CACHED)
  },
  [actionTypes.DASHBOARD_CHANGE_FILTER] ({commit, dispatch, state}, filterObject) {
    // Toggle dashboard filter buttons
    commit(mutationTypes.TOGGLE_DASHBOARD_FILTER, filterObject)
    // Toggle my students filter buttons
    commit(mutationTypes.TOGGLE_STUDENTS_LIST_FILTER, filterObject)
    // Toggle interactions filter buttons
    commit(mutationTypes.TOGGLE_INTERACTIONS_LIST_FILTER, filterObject)

    // Call endpoints for dashboard
    dispatch(actionTypes.GET_STUDENTS_COUNT)
    dispatch(actionTypes.GET_LATEST_ENGAGEMENT_COUNT)
    dispatch(actionTypes.GET_DASHBOARD_ALERTS_COUNT)
    dispatch(actionTypes.GET_INTERVENTION_COUNT)
    // Call endpoints for my students
    commit(mutationTypes.SOFT_RESET_STUDENT_LIST)
    dispatch(actionTypes.GET_LIST_OF_STUDENTS)
    // Call endpoints for interactions
    commit(mutationTypes.EMPTY_INTERACTIONS_LIST)
    dispatch(actionTypes.GET_INTERACTIONS_LIST_START)
  },
  [actionTypes.GET_DASHBOARD_AVAILABLE_CHART] ({rootState, state, commit}) {
    const actionData = { action: actionTypes.GET_DASHBOARD_AVAILABLE_CHART }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(mutationTypes.SET_DASHBOARD_AVAILABLE_CHARTS, res.data)
      })
      .catch((err) => {
        console.log('Failed to get available chart')
        console.error(err)
      })
  },
  [actionTypes.GET_CHART_FOR_STAFF] ({rootState, state, commit, dispatch}, {chartId}) {
    const actionData = { action: actionTypes.GET_CHART_FOR_STAFF, data: chartId }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/create/${chartId}`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(mutationTypes.APPEND_DASHBOARD_GRAPH, res.data)
        dispatch(actionTypes.GET_DASHBOARD_GRAPHS_DATA, {action: {chartId: res.data.id, append: true, update: false}, chartType: res.data.chartType})
        dispatch(actionTypes.GET_CHART_LIMIT_BOOLEAN)
        dispatch(actionTypes.UPDATE_DASHBOARD_GRAPH_SEQUENCE, state.dashboardGraphs)
      })
      .catch((err) => {
        console.log('Failed to create staff chart')
        console.error(err)
      })
  },
  [actionTypes.GET_DASHBOARD_GRAPHS] ({commit, rootState, dispatch}, action) {
    action = !action ? {chartId: null, append: false, update: false} : action
    const actionData = { action: actionTypes.GET_DASHBOARD_GRAPHS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/staff/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: actionData
    })
      .then((res) => {
        commit(mutationTypes.SET_DASHBOARD_GRAPHS, res.data)
        commit(mutationTypes.RESET_DASHBOARD_GRAPHS_DATA)
        action.count = 0
        res.data.forEach(el => {
          action.chartId = el.id
          dispatch(actionTypes.GET_DASHBOARD_GRAPHS_DATA, {action: action, chartType: el.chartType})
        })
      })
      .catch((err) => {
        console.log('Failed to get all staff charts')
        console.error(err)
      })
  },
  [actionTypes.GET_DASHBOARD_GRAPHS_DATA] ({commit, rootState, state, dispatch}, {action, chartType}) {
    commit(mutationTypes.DASHBOARD_CHARTS_LOADING)
    const actionData = { action: actionTypes.GET_DASHBOARD_GRAPHS_DATA, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/staff/data/${action.chartId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: actionData
    })
      .then((res) => {
        let pollingFrequency = rootState.config.reportPollingDuration / rootState.config.reportPollingFrequency
        let pollingCount = 1
        dispatch(actionTypes.CHECK_IF_GRAPH_AVAILABLE, {pollingFrequency: pollingFrequency, pollingCount: pollingCount, reportId: res.data.id, action: action, chartType: chartType})
      })
      .catch((err) => {
        console.log('Failed to get graph data')
        console.error(err)
        commit(mutationTypes.DASHBOARD_CHARTS_NOT_LOADING, true)
      })
  },
  [actionTypes.CHECK_IF_GRAPH_AVAILABLE] ({commit, dispatch, rootState, state}, reportObject) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/staff/data/${reportObject.reportId}/available`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: actionTypes.CHECK_IF_GRAPH_AVAILABLE}
    })
      .then((res) => {
        if (!res.data && reportObject.pollingCount !== reportObject.pollingFrequency) {
          let pollingTimeout = rootState.config.reportPollingFrequency
          setTimeout(() => {
            dispatch(actionTypes.CHECK_IF_GRAPH_AVAILABLE, {
              pollingFrequency: reportObject.pollingFrequency,
              pollingCount: reportObject.pollingCount + 1,
              reportId: reportObject.reportId,
              action: reportObject.action,
              chartType: reportObject.chartType
            })
          }, pollingTimeout)
        } else {
          dispatch(actionTypes.DOWNLOAD_GRAPH_DATA, reportObject)
        }
      }).catch((err) => {
        console.log('Failed to check graph data availability')
        console.error(err)
        commit(mutationTypes.DASHBOARD_CHARTS_NOT_LOADING, true)
      })
  },
  [actionTypes.DOWNLOAD_GRAPH_DATA] ({commit, rootState, state}, reportObject) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/staff/data/${reportObject.reportId}/download`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: actionTypes.DOWNLOAD_GRAPH_DATA}
    }).then(res => {
      reportObject.action.count++
      if (reportObject.chartType === 'DOUGHNUT') {
        if (res.data.chartData) {
          res.data.chartData.forEach(function (item, index) {
            item.colour = store.state.config.ratingColour[index]
            item.identifier = store.state.config.ratingLabel[index]
          })
        }
      }
      if (reportObject.action.append) {
        commit(mutationTypes.APPEND_DASHBOARD_GRAPH_DATA, res.data)
        // release CHART_UPDATED when new chart created (only 1 chart data is requested rather than all)
        commit(mutationTypes.SET_CHART_UPDATED, true)
      } else if (reportObject.action.update) {
        commit(mutationTypes.SET_DASHBOARD_GRAPHS_DATA, res.data)
      } else {
        commit(mutationTypes.SET_DASHBOARD_GRAPHS_DATA, res.data)
      }
      commit(mutationTypes.DASHBOARD_CHARTS_NOT_LOADING)

      // only release CHART_UPDATED once graph intake complete
      // In communication with charts to animate when updated (chartUpdated watcher)
      if (state.dashboardGraphs.length === reportObject.action.count) {
        commit(mutationTypes.SET_CHART_UPDATED, true)
      }
    }).catch(err => {
      console.log('Failed to get graph data')
      console.error(err)
      commit(mutationTypes.DASHBOARD_CHARTS_NOT_LOADING, true)
    })
  },
  [actionTypes.UPDATE_DASHBOARD_GRAPH_FILTERS] ({commit, rootState, state, dispatch}, filterObject) {
    let chartId = state.selectedChartId
    let filters = {}
    filters.search = getAppliedFilters(state.chartFilterFields)
    solveCustomFilters(filters.search, state.customFilterNames)
    filters.search.description = filterObject.title
    filters.search.defaultSearch = filterObject.id ? filterObject.defaultSearch : false
    filters.search.id = filterObject.id
    filters.lastWeekNumber = (state.startDate !== null && state.endDate !== null) ? 0 : state.lastWeekNumber
    filters.searchFromDate = state.startDate
    filters.searchToDate = state.endDate
    return axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/staff/search/update/${chartId}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: filters,
      actionData: { action: actionTypes.UPDATE_DASHBOARD_GRAPH_FILTERS, data: filters }
    }).then(res => {
      dispatch(actionTypes.GET_DASHBOARD_GRAPHS, {chartId: chartId, append: false, update: true})

      commit(mutationTypes.SET_CHART_TITLE, {chartId: chartId, title: filterObject.title})
      commit(mutationTypes.SET_UPDATED_CHART_ID, chartId)

      dispatch(actionTypes.GET_SAVED_FILTERS_FOR_CHARTS_ENDPOINT)

      // only call myStudents filter endpoint if myStudents has filter active or isNew
      let filterActive = Object.keys(rootState.students.filterFields.myFilterIds.values).length > 0
      if (filterActive || !filterObject.id) {
        dispatch(actionTypes.GET_SAVED_FILTERS_FOR_STAFF, checkMatch(getAppliedFilters(rootState.students.filterFields).myFilterIds, filterObject.id))
      }
    }).catch(err => {
      console.error(err)
    })
  },
  [actionTypes.DELETE_DASHBOARD_CHART] ({rootState, state, commit, dispatch}, {id, toBeDeleted}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/delete/${id}/${toBeDeleted}`,
      method: 'delete',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: actionTypes.DELETE_DASHBOARD_CHART, data: {id, toBeDeleted}}
    }).then(() => {
      if (toBeDeleted) {
        commit(mutationTypes.SAVE_DELETED_CHART_ID, id)
        commit(mutationTypes.SET_UNDO_TYPE, undoTypes.CHART_DELETED)
        dispatch(actionTypes.SET_UNDO_STATE_ASYNC, true)
        commit(mutationTypes.HIDE_CHART_BY_ID, id)
      } else {
        dispatch(actionTypes.SET_UNDO_STATE_ASYNC, false)
        commit(mutationTypes.SHOW_CHART_BY_ID, id)
      }
      commit(mutationTypes.REFRESH_PRIMARY_DASHBOARD_GRAPHS_SEQUENCE, state.dashboardGraphs)
      commit(mutationTypes.REFRESH_SECONDARY_DASHBOARD_GRAPHS_SEQUENCE, state.dashboardGraphs)
      dispatch(actionTypes.GET_CHART_LIMIT_BOOLEAN)
    }).catch((err) => {
      console.error(err)
      if (toBeDeleted) {
        console.log(`Failed delete chart with id ${id}`)
        console.error(err)
      } else {
        console.log(`Failed to undo chart deletion with id ${id}`)
        console.error(err)
      }
    })
  },
  [actionTypes.GET_COURSES_FOR_CHARTS] ({commit, dispatch, rootState}) {
    const actionData = { action: actionTypes.GET_COURSES_FOR_CHARTS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/course/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(mutationTypes.SET_COURSES_FOR_CHARTS, res.data)
        dispatch(actionTypes.GET_STUDY_MODES_CHARTS)
      })
      .catch((err) => {
        console.log('Failed to get courses filters')
        console.error(err)
        dispatch(actionTypes.GET_STUDY_MODES_CHARTS)
      })
  },
  [actionTypes.GET_STUDY_MODES_CHARTS] ({commit, dispatch, rootState}) {
    const actionData = {action: actionTypes.GET_STUDY_MODES_CHARTS}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/custom_list/codeDescription/StudyMode/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'studyModes',
          filterName: 'student.filters.headers.study_mode',
          filterAdditionalDescription: 'student.filters.headers.study_mode_additional_description'
        }
        if (res.data.length > 6) {
          commit(mutationTypes.SET_CHART_LIST_FILTER_TYPE, {filters: res.data, chartFilterObject: filterObject})
        } else {
          commit(mutationTypes.SET_CHART_BUTTON_FILTER_TYPE, {filters: res.data, chartFilterObject: filterObject})
        }
        if (rootState.profile.loginToken && rootState.profile.loginToken.length > 0) {
          dispatch(actionTypes.GET_COURSE_YEARS_CHARTS)
        }
      })
      .catch((err) => {
        console.log('Failed to get study mode filters')
        console.error(err)
        if (rootState.profile.loginToken && rootState.profile.loginToken.length > 0) {
          dispatch(actionTypes.GET_COURSE_YEARS_CHARTS)
        }
      })
  },
  [actionTypes.GET_COURSE_YEARS_CHARTS] ({commit, dispatch, rootState}) {
    const actionData = {action: actionTypes.GET_COURSE_YEARS_CHARTS}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/custom_list/courseYear/CourseYear/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        Object.keys(res.data)
          .forEach(key => {
            res.data[key].code = parseInt(res.data[key].code)
          })
        let filterObject = {
          filterIdentifier: 'courseYears',
          filterName: 'student.filters.headers.year',
          filterAdditionalDescription: 'student.filters.headers.year_additional_description'
        }
        if (res.data.length > 6) {
          commit(mutationTypes.SET_CHART_LIST_FILTER_TYPE, {filters: res.data, chartFilterObject: filterObject})
        } else {
          commit(mutationTypes.SET_CHART_BUTTON_FILTER_TYPE, {filters: res.data, chartFilterObject: filterObject})
        }
        if (rootState.profile.loginToken && rootState.profile.loginToken.length > 0) {
          dispatch(actionTypes.GET_COURSE_LEVELS_CHARTS)
        }
      })
      .catch((err) => {
        console.log('Failed to get study mode filters')
        console.error(err)
        if (rootState.profile.loginToken && rootState.profile.loginToken.length > 0) {
          dispatch(actionTypes.GET_COURSE_LEVELS_CHARTS)
        }
      })
  },
  [actionTypes.GET_COURSE_LEVELS_CHARTS] ({commit, dispatch, rootState}) {
    const actionData = {action: actionTypes.GET_COURSE_LEVELS_CHARTS}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/custom_list/codeDescription/CourseLevel/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'courseLevels',
          filterName: 'student.filters.headers.level',
          filterAdditionalDescription: 'student.filters.headers.level_additional_description'
        }
        if (res.data.length > 6) {
          commit(mutationTypes.SET_CHART_LIST_FILTER_TYPE, {filters: res.data, chartFilterObject: filterObject})
        } else {
          commit(mutationTypes.SET_CHART_BUTTON_FILTER_TYPE, {filters: res.data, chartFilterObject: filterObject})
        }
        if (rootState.profile.loginToken && rootState.profile.loginToken.length > 0) {
          dispatch(actionTypes.GET_ENROLMENT_STATUS_CHARTS)
        }
      })
      .catch((err) => {
        console.log('Failed to get course levels alert filter')
        console.error(err)
        if (rootState.profile.loginToken && rootState.profile.loginToken.length > 0) {
          dispatch(actionTypes.GET_ENROLMENT_STATUS_CHARTS)
        }
      })
  },
  [actionTypes.GET_ENROLMENT_STATUS_CHARTS] ({commit, dispatch, rootState}) {
    const actionData = {action: actionTypes.GET_ENROLMENT_STATUS_CHARTS}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/enrolmentstatus/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'enrolmentStatus',
          filterName: 'student.filters.headers.enrolment_status',
          filterAdditionalDescription: 'student.filters.headers.enrolment_status_additional_description'
        }
        let visibleCodes = res.data.filter(enrolCode => enrolCode.visible === true)
        if (visibleCodes.length > 6) {
          commit(mutationTypes.SET_CHART_LIST_FILTER_TYPE, {filters: visibleCodes, chartFilterObject: filterObject})
        } else {
          commit(mutationTypes.SET_CHART_BUTTON_FILTER_TYPE, {filters: visibleCodes, chartFilterObject: filterObject})
        }
        if (rootState.profile.loginToken && rootState.profile.loginToken.length > 0) {
          dispatch(actionTypes.GET_CUSTOM_FILTERS_FOR_CHARTS)
        }
      })
      .catch((err) => {
        console.log('Failed to get enrolment status filters')
        console.error(err)
        if (rootState.profile.loginToken && rootState.profile.loginToken.length > 0) {
          dispatch(actionTypes.GET_CUSTOM_FILTERS_FOR_CHARTS)
        }
      })
  },
  [actionTypes.GET_CUSTOM_FILTERS_FOR_CHARTS] ({state, commit, dispatch, rootState}) {
    const actionData = {action: actionTypes.GET_CUSTOM_FILTERS_FOR_CHARTS}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/filter/student/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filters = res.data
        Object.keys(filters).forEach((filter) => {
          let filterIdentifier = filters[filter].filterIdentifier
          if (filters[filter].filterStyle === 'button') {
            commit(mutationTypes.SET_CHART_CUSTOM_BUTTON_FILTER_TYPE, {filters, filter, filterIdentifier})
          } else {
            commit(mutationTypes.SET_CHART_CUSTOM_LIST_FILTER_TYPE, {filters, filter, filterIdentifier})
          }
        })
        dispatch(actionTypes.GET_SAVED_FILTERS_FOR_CHARTS_ENDPOINT)
      })
      .catch((err) => {
        console.log('Failed to get custom filters')
        console.error(err)
      })
  },
  [actionTypes.GET_SAVED_FILTERS_FOR_CHARTS] ({commit, dispatch, rootState, state}, chartId) {
    dispatch(actionTypes.CLEAR_CHART_FILTERS_ACTION)

    let myFilter = state.dashboardGraphs.filter(el => el.id === chartId)[0]
    dispatch(actionTypes.ORGANISE_SAVED_FILTERS_FOR_CHART, myFilter.search)
    dispatch(actionTypes.ORGANISE_FILTER_DATES_FOR_CHART, myFilter)
  },
  [actionTypes.GET_SAVED_FILTERS_FOR_CHARTS_ON_SELECTION] ({commit, dispatch, rootState, state}, filterObject) {
    dispatch(actionTypes.CLEAR_CHART_FILTERS_ACTION)

    let filters = state.chartFilterFields.myFilterIds.myFilters
    Object.keys(filters).forEach(filter => {
      let myFilter = filters[filter]
      let isSelected = myFilter.id === Object.values(filterObject.filterName)[0]
      if (isSelected) {
        dispatch(actionTypes.ORGANISE_SAVED_FILTERS_FOR_CHART, myFilter)
      }
    })
  },
  [actionTypes.ORGANISE_FILTER_DATES_FOR_CHART] ({state, commit, rootState}, myFilter) {
    // refresh dates
    commit(mutationTypes.REFRESH_CHART_DATES)

    if (myFilter && !myFilter.deleted) {
      // set dates
      commit(mutationTypes.SET_CHART_START_DATE_FILTER, myFilter.searchFromDate)
      commit(mutationTypes.SET_CHART_END_DATE_FILTER, myFilter.searchToDate)

      let lastWeekSum = myFilter.lastWeekNumber
      if (isNew(myFilter)) {
        lastWeekSum = 1
      }
      commit(mutationTypes.SET_CHART_LAST_WEEK_NUMBER, lastWeekSum)
    }
  },
  [actionTypes.ORGANISE_SAVED_FILTERS_FOR_CHART] ({state, commit, rootState}, myFilter) {
    if (myFilter && !myFilter.deleted) {
      // set myFilters button
      let ids = []
      ids.push(myFilter.id)
      commit(mutationTypes.SET_CHARTS_LIST_FILTER_ARRAY, {filterType: 'myFilterIds', filterName: ids})

      // include custom filter
      concatCustomFilters(myFilter)

      Object.keys(myFilter).forEach(key => {
        if (state.chartFilterFields.hasOwnProperty(key)) {
          // set (myFilters) filters
          if (state.chartFilterFields[key].isList) {
            commit(mutationTypes.SET_CHARTS_LIST_FILTER_ARRAY, {filterType: key, filterName: myFilter[key]})
          } else {
            commit(mutationTypes.TOGGLE_CHARTS_LIST_FILTER, {filterType: key, filterName: myFilter[key]})
          }
        }
      })
    }

    if (!rootState.rightDrawer.state) {
      commit(mutationTypes.SET_DRAWER_COMPONENT, components.CREATE_CHART_FILTER)
      commit(mutationTypes.SET_DRAWER_COMPONENT_TITLE, componentTitles.CREATE_CHART_FILTER)
      commit(mutationTypes.RESET_INTERVENTION_MODULE)
      commit(mutationTypes.RESET_EXEMPTION_MODULE)
      commit(mutationTypes.SET_DRAWER_STATE, true)
    }
  },
  [actionTypes.GET_SAVED_FILTERS_FOR_CHARTS_ENDPOINT] ({commit, dispatch, rootState}) {
    const actionData = { action: actionTypes.GET_SAVED_FILTERS_FOR_CHARTS_ENDPOINT, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/search/staff/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(mutationTypes.SET_SAVED_FILTERS_FOR_CHARTS, res.data)
      })
      .catch((err) => {
        console.error(err)
        console.log(`Failed to get saved filters for staff`)
      })
  },
  [actionTypes.CLEAR_CHART_FILTERS_ACTION] ({commit}) {
    // Clear all chart filters
    commit(mutationTypes.CLEAR_CHART_FILTERS_LIST)
    // Clear list types
    Object.keys(state.listSources).forEach((filterType) => {
      commit(mutationTypes.SET_CHARTS_LIST_FILTER_ARRAY, {filterName: [], filterType: filterType})
    })
  },
  [actionTypes.UPDATE_DASHBOARD_GRAPH_SEQUENCE] ({rootState, state, commit, dispatch}, graphs) {
    // Suppress snackbar if secondary sequence is undefined, denoting new chart just created
    let suppressSnackbar = (graphs[0].secondarySequence === undefined)
    commit(mutationTypes.REFRESH_PRIMARY_DASHBOARD_GRAPHS_SEQUENCE, graphs)
    commit(mutationTypes.REFRESH_SECONDARY_DASHBOARD_GRAPHS_SEQUENCE, graphs)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/chart/reorder`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: graphs,
      actionData: { action: actionTypes.UPDATE_DASHBOARD_GRAPH_SEQUENCE, data: graphs }
    })
      .then((res) => {
        if (!suppressSnackbar) {
          commit(mutationTypes.SET_INFORMATION_SNACKBAR_TEXT, informationTexts.CHART_REORDER_APPLIED)
          commit(mutationTypes.SET_INFORMATION_SNACKBAR_STATE, true)
        }
      })
      .catch((err) => {
        console.log('Failed to reorder charts')
        console.error(err)
      })
  }
}

export const isNew = (filter) => {
  let sd = filter.searchFromDate
  let ed = filter.searchToDate
  let lw = filter.lastWeekNumber
  return sd === undefined && ed === undefined && lw === 0
}

export const checkMatch = (currentStudentFilter, chartFilter) => {
  let ids = []
  if (chartFilter) {
    ids.push(chartFilter)
  }
  return parseInt(currentStudentFilter) === chartFilter
    ? {filterName: ids, filterType: 'myFilterIds'}
    : {filterName: ids, filterType: 'myFilterIds', hold: true}
}

export const refreshSeq = (graphs, element) => {
  let seq = 1
  graphs.forEach(el => {
    if (!el.isHidden) {
      el[element] = seq++
    }
  })
  return graphs
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardModule.js